import axios, {AxiosError} from 'axios';
import { LocalStoreKeys } from 'src/app/shared/helpers/localstorage/local-store';
import { environment } from 'src/environments/environment';

const BASE_URL = environment.GATEWAY

const currentUser = JSON.parse(localStorage.getItem(LocalStoreKeys.currentUser));

let store: any;

export const injectStore = (_store: any) => {
  store = _store
}

export const api = axios.create({
    baseURL: BASE_URL,
    headers: {        
        "Content-Type": "application/json"
    }
});

api.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
api.defaults.headers.common['Authorization'] = `Bearer ${currentUser?.token?.accessToken}`

